import React, { useState } from 'react';
import { motion } from 'framer-motion';
import ApiSettings from '../components/Settings/ApiSettings';
import EmailSettings from '../components/Settings/EmailSettings';
import CallSettings from '../components/Settings/CallSettings';
import NotificationSettings from '../components/Settings/NotificationSettings';
import DatabaseSettings from '../components/Settings/DatabaseSettings';
import SafeIcon from '../common/SafeIcon';
import { FiBell, FiDatabase, FiKey, FiMail, FiPhone } from 'react-icons/fi';


const Settings = () => {
  const [activeTab, setActiveTab] = useState('database');

  const tabs = [
    { id: 'database', label: 'Database', icon: FiDatabase },
    { id: 'api', label: 'API Settings', icon: FiKey },
    { id: 'email', label: 'Email Settings', icon: FiMail },
    { id: 'calls', label: 'Call Settings', icon: FiPhone },
    { id: 'notifications', label: 'Notifications', icon: FiBell }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'database':
        return <DatabaseSettings />;
      case 'api':
        return <ApiSettings />;
      case 'email':
        return <EmailSettings />;
      case 'calls':
        return <CallSettings />;
      case 'notifications':
        return <NotificationSettings />;
      default:
        return <DatabaseSettings />;
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-600">
          Configure your CRM preferences and integrations
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
        {/* Sidebar Navigation */}
        <div className="lg:col-span-1">
          <nav className="space-y-2">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-colors ${
                  activeTab === tab.id
                    ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700'
                    : 'text-gray-600 hover:bg-gray-50'
                }`}
              >
                <SafeIcon icon={tab.icon} className={`text-lg ${activeTab === tab.id ? 'text-blue-700' : 'text-gray-400'}`} />
                <span className="font-medium">{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Content Area */}
        <div className="lg:col-span-3">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.2 }}
            className="bg-white rounded-lg shadow-sm border border-gray-200"
          >
            {renderTabContent()}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Settings;